import {
  SegmentActionName,
  SegmentObjectName,
  track,
  TrackingEventName,
  trackLegacyEvent,
} from '@heidi/analytics/events';
import { type EHRProvider } from '@heidi/schema/ml-scribe';

export function widgetLinkAccountStartTrialClicked(params: { integrationName?: string }) {
  trackLegacyEvent({
    name: SegmentObjectName.Integration,
    props: {
      ehrProvider: params.integrationName as EHRProvider, // this is just a string anyway
      action: SegmentActionName.WidgetLinkAccountStartTrialClicked,
    },
  });

  // V2
  track({
    event_name: TrackingEventName.ButtonClicked,
    props: {
      label: 'widget_link_account_start_trial_clicked',
      feature: 'integration',
    },
  });
}
